// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form a[data-v-d24ccde8]{margin-left:20px;font-size:13px;color:#00f}.table input[data-v-d24ccde8]{width:100px}", ""]);
// Exports
module.exports = exports;
